import React, { useEffect, useState } from "react";
import FormHeader from "../../../components/dms_common/FormHeader";
import CustomAccordian from "../../../components/dms_common/CustomAccordian";
import BorderHeading from "../../../components/heading/BorderHeading";
import CustomDataGrid from "../../../components/dms_common/CustomDataGrid";
import { useLocation, useNavigate } from "react-router-dom";
import StockAdjustRejectionModal from "../modal/StockAdjustRejectionModal";
import { StockTypeUpdateRowsData, StockTypeUpdateSkuDetail } from "../../../types/types";
import {
  StockTypeUpdateSkuDetailsGridMetaData,
  StockTypeUpdateSkuDetailsMetaData1,
  StockTypeUpdateSkuDetailsMetaData2,
  StockTypeUpdateStatusMapping,
} from "./StockTypeUpdateUtils";

interface skuDetailsRowsData {
  id: string;
  batchId: string;
  updatedPieceQuantity: number;
  updatedCaseQuantity: number;
  updatedOtherQuantity: number;
  reason: string;
  toStatus: string;
  status: string;
  otherUnitName?: string | undefined;
}

const StockTypeUpdateSkuDetailsScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const productData = location.state as StockTypeUpdateRowsData;
  const [rows, setRows] = useState<skuDetailsRowsData[]>([]);
  const [isExpanded, setIsExpanded] = useState(false);

  const onCustomAccordionToggle = (isExpanded: boolean) => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const tempSkuDetails: skuDetailsRowsData[] = [];
    productData.skuDetails.forEach((item: StockTypeUpdateSkuDetail) => {
      // Handle both old and new API response formats
      const pieceQty = item.pieceQty || 0;
      const caseQty = item.caseQty || 0;
      const otherQty = item.otherQty || 0;
      
      // Format the updated quantity string
      const updatedQtyParts = [];
      if (caseQty > 0) updatedQtyParts.push(`${caseQty} Cs`);
      if (pieceQty > 0) updatedQtyParts.push(`${pieceQty} Pc`);
      if (otherQty > 0) updatedQtyParts.push(`${otherQty} Ot`);
      
      tempSkuDetails.push({
        id: item.batchId,
        batchId: item.batchId,
        updatedPieceQuantity: item.pieceQty,
        updatedCaseQuantity: item.caseQty,
        updatedOtherQuantity: item.otherQty,
        reason: item.reason,
        toStatus: item.toStatus,
        status: productData?.fromStatus,
        otherUnitName: productData?.otherUnitName,
      });
    });
    setRows(tempSkuDetails);
  }, []);

  return (
    <div className="view_order_parent_vo" style={{ height: "100%" }}>
      <div className="view_order_header_with_search">
        <div className="view_order_header">
          <FormHeader
            parentLabel={"Stock Type update"}
            label={"SKU Details"}
            goBackToParent={() => navigate(-1)}
          />
        </div>
      </div>
      <CustomAccordian
        expanded={!isExpanded}
        onCustomAccordionToggle={onCustomAccordionToggle}
        isSecondHalf={true}
        metaData1={StockTypeUpdateSkuDetailsMetaData1}
        data1={productData}
        metaData2={StockTypeUpdateSkuDetailsMetaData2}
        data2={productData}
        header={`Status for SKU Code ${productData.skuCode}`}
        label1={""}
        label2=""
        dateAndTimeLabel=""
        status={productData?.fromStatus}
        singleColumnInEachHalf={true}
      />
      <div>
        <div className="view_order_button_container">
          <BorderHeading>View Details</BorderHeading>
        </div>
      </div>
      <CustomDataGrid
        rows={rows}
        columnsMetaData={StockTypeUpdateSkuDetailsGridMetaData}
        orderStatusConfig={StockTypeUpdateStatusMapping}
        tableWidth={0.765}
        enableRowClickRedirect={false}
      />
      <StockAdjustRejectionModal heading={productData.skuDescription} />
    </div>
  );
};

export default StockTypeUpdateSkuDetailsScreen;
